export interface PowProgress {
  attempts: number;
  elapsedMs: number;
}

export function solvePow(
  prefix: string,
  difficulty: number,
  onProgress?: (p: PowProgress) => void,
): { promise: Promise<string>; cancel: () => void } {
  const worker = new Worker(new URL("./pow.worker.ts", import.meta.url), { type: "module" });
  let resolveFn: (nonce: string) => void = () => {};
  let rejectFn: (err: Error) => void = () => {};
  const promise = new Promise<string>((res, rej) => {
    resolveFn = res;
    rejectFn = rej;
  });
  worker.onmessage = (ev) => {
    const m = ev.data as
      | { type: "progress"; attempts: number; elapsedMs: number }
      | { type: "done"; nonce: string }
      | { type: "cancelled" };
    if (m.type === "progress") onProgress?.({ attempts: m.attempts, elapsedMs: m.elapsedMs });
    else if (m.type === "done") {
      resolveFn(m.nonce);
      worker.terminate();
    } else if (m.type === "cancelled") {
      rejectFn(new Error("cancelled"));
      worker.terminate();
    }
  };
  worker.onerror = (e) => {
    rejectFn(new Error(`worker error: ${e.message}`));
    worker.terminate();
  };
  worker.postMessage({ type: "start", prefix, difficulty });
  return {
    promise,
    cancel: () => worker.postMessage({ type: "cancel" }),
  };
}